import { CoreMenu } from "@core/types";
import { ROLE } from "app/main/shared/enums/Roles.enum";
import { cloneDeep } from "lodash";

export const menu: CoreMenu[] = [
  {
    id: "dashboard",
    title: "Inicio",
    type: "item",
    icon: "home",
    url: "dashboard",
    module: "dashboard",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
  },
  {
    id: "plan",
    title: "Planes",
    type: "item",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN],
    icon: "credit-card",
    url: "planes",
    module: "plan",
  },
  {
    id: "sender",
    title: "Remitentes",
    type: "item",
    role: [ROLE.SUPER_ADMIN],
    icon: "send",
    url: "remitentes",
    module: "sender",
  },
  {
    id: "category",
    title: "Categorías",
    type: "item",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN],
    icon: "list",
    url: "categorias",
    module: "category",
  },
  {
    id: "country",
    title: "Países",
    type: "item",
    role: [ROLE.SUPER_ADMIN],
    icon: "globe",
    url: "paises",
    module: "country",
  },
  {
    id: "customers",
    title: "Clientes",
    type: "collapsible",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN],
    icon: "users",
    children: [
      {
        id: "customers",
        title: "Administrar clientes",
        icon: "settings",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN],
        type: "item",
        url: "clientes/admin",
        //module: "summary",
      },
      {
        id: "resumen",
        title: "Resumen de consumo",
        icon: "bar-chart",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN],
        type: "item",
        url: "clientes/consumo",
        //module: "summary",
      },
    ],
    module: "customers",
  },
  {
    id: "products",
    title: "Productos",
    type: "item",
    role: [ROLE.SUPER_ADMIN],
    icon: "shopping-cart",
    url: "productos",
    module: "products",
  },
  {
    id: "security",
    title: "Seguridad",
    type: "collapsible",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
    icon: "shield",
    children: [
      {
        id: "blacklist",
        title: "Lista negra",
        icon: "corner-down-right",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        type: "item",
        url: "seguridad/lista-negra",
      },
      {
        id: "blackout",
        title: "Horario fuera de línea",
        icon: "corner-down-right",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        type: "item",
        url: "seguridad/black-out",
      },
      {
        id: "words",
        title: "Palabras no permitidas",
        icon: "corner-down-right",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        type: "item",
        url: "seguridad/palabras-no-permitidas",
      },
    ],
    module: "security",
  },
  {
    id: "admin",
    title: "Administración",
    type: "collapsible",
    icon: "settings",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SUBADMIN],
    children: [
      {
        id: "users",
        title: "Usuarios",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SUBADMIN],
        type: "item",
        icon: "corner-down-right",
        url: "admin/usuarios",
      },
      {
        id: "user-limits",
        title: "Límites de usuario",
        role: [ROLE.SUBADMIN],
        type: "item",
        icon: "corner-down-right",
        url: "admin/limites-de-usuario",
      },
      {
        id: "agenda",
        title: "Agenda de cambios",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN],
        type: "item",
        icon: "corner-down-right",
        url: "admin/agenda-cambios",
      },
      {
        id: "settings",
        title: "Configuración",
        role: [ROLE.SUPER_ADMIN],
        type: "item",
        icon: "corner-down-right",
        url: "admin/configuracion",
      },
      {
        id: "owner-senders",
        title: "Remitentes",
        role: [ROLE.ADMIN],
        type: "item",
        icon: "corner-down-right",
        url: "admin/remitentes",
      },
    ],
    module: "admin",
  },
  {
    id: "sms",
    title: "SMS",
    type: "collapsible",
    role: [ROLE.SENDER, ROLE.SUBADMIN],
    icon: "message-square",
    children: [
      {
        id: "single-send",
        title: "Envío rápido",
        type: "item",
        role: [ROLE.SENDER, ROLE.SUBADMIN],
        icon: "corner-down-right",
        url: "sms/rapido",
      },
      {
        id: "bulk-send",
        title: "Envío con archivo",
        type: "item",
        role: [ROLE.SENDER, ROLE.SUBADMIN],
        icon: "corner-down-right",
        url: "sms/archivo",
      },
    ],
    module: "sms",
  },
  {
    id: "whatsapp",
    title: "WhatsApp",
    type: "collapsible",
    role: [ROLE.SENDER, ROLE.SUBADMIN],
    data: {
      hasNotifications: true,
    },
    icon: "message-circle",
    children: [
      {
        id: "single-send",
        title: "Envío rápido",
        type: "item",
        role: [ROLE.SUPER_ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        icon: "corner-down-right",
        url: "whatsapp/rapido",
      },
      /* {
        id: "bulk-send",
        title: "Envío con archivo",
        type: "item",
        role: [ROLE.SUPER_ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        icon: "corner-down-right",
        url: "whatsapp/archivo",
      }, */
      /* {
        id: "chat",
        title: "Chat",
        type: "item",
        role: [ROLE.SUPER_ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        icon: "corner-down-right",
        url: "whatsapp/chat",
      }, */
      {
        id: "templates",
        title: "Plantillas",
        type: "item",
        role: [ROLE.SUPER_ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        icon: "corner-down-right",
        url: "whatsapp/plantillas",
      },
    ],
    module: "whatsapp",
  },
  {
    id: "email",
    title: "Correo",
    icon: "mail",
    type: "collapsible",
    role: [ROLE.SENDER, ROLE.SUBADMIN],
    children: [
      {
        id: "envio",
        title: "Envío rápido",
        type: "item",
        role: [ROLE.SENDER, ROLE.SUBADMIN],
        icon: "corner-down-right",
        url: "email/envio",
      },
    ],
    module: "email",
  },
  {
    id: "reports",
    title: "Reportes",
    type: "collapsible",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
    icon: "pie-chart",
    children: [
      {
        id: "invoices",
        title: "Mensajes enviados",
        icon: "corner-down-right",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        type: "item",
        url: "reportes/sms-enviados",
      },
      {
        id: "invoices",
        title: "Envíos masivos",
        icon: "corner-down-right",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        type: "item",
        url: "reportes/archivos-procesados",
      },
      {
        id: "scheduled",
        title: "Envíos programados",
        icon: "corner-down-right",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        type: "item",
        url: "reportes/archivos-programados",
      },
      {
        id: "emg",
        title: "Envíos SMSC",
        type: "item",
        role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
        icon: "corner-down-right",
        url: "reportes/emg-enviados",
        module: "emg",
      },
    ],
    module: "reports",
  },
  {
    id: "invoices",
    title: "Facturación",
    icon: "file-text",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN],
    type: "item",
    url: "facturacion/reporte",
    module: "invoices",
  },
  {
    id: "log",
    title: "Bitácora",
    icon: "monitor",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
    type: "item",
    url: "bitacora/reporte",
    module: "log",
  },
  {
    id: "archive",
    title: "Fichero de archivos",
    type: "item",
    role: [ROLE.SUPER_ADMIN, ROLE.ADMIN, ROLE.SENDER, ROLE.SUBADMIN],
    data: {
      hasNotifications: true,
    },
    icon: "archive",
    url: "archivos-guardados",
    module: "archive",
  },
  {
    id: "support",
    title: "Soporte",
    type: "collapsible",
    icon: "settings",
    role: [ROLE.SUPER_ADMIN],
    children: [
      /* {
        id: "support-task",
        title: "Tareas Soporte",
        role: [ROLE.SUPER_ADMIN],
        type: "item",
        icon: "corner-down-right",
        url: "soporte/tareas-soporte",
      }, */
      {
        id: "app-params",
        title: "Parámetros de aplicación",
        role: [ROLE.SUPER_ADMIN],
        type: "item",
        icon: "corner-down-right",
        url: "soporte/parametros",
      },
      {
        id: "app-params",
        title: "Registros servidor",
        role: [ROLE.SUPER_ADMIN],
        type: "item",
        icon: "corner-down-right",
        url: "soporte/registros-servidor",
      },
      {
        id: "llaves-aotp",
        title: "Configuración AOTP",
        role: [ROLE.SUPER_ADMIN],
        type: "item",
        icon: "corner-down-right",
        url: "soporte/llaves-aotp",
      },
    ],
    module: "support",
  },
];

export const defaultMenu = cloneDeep(menu);
